import store from '@/commons/store'
import Vue from 'vue'

export default class CookiesUtils {
    static atualizarCookies(cookies) {
        const cookie = JSON.stringify(cookies)
        Vue.$cookies.set(store.getters.nomeCookieUsuario, cookie, Infinity)
    }
}